import React from 'react';

const AppleIconSvg = () => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        style={{ border: '2px solid #D9D9D9', borderRadius: 4 }}
    >
        <path
            fill="#1A1A1A"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.012 13c-.997.046-2.222.679-2.947 1.516-.657.747-1.223 1.946-.065 3.1 1.112.091 2.268-.565 2.972-1.402.703-.86 1.179-2.036 1.043-3.214zM27.99 17.842c-1.564-.159-3.06.927-3.854.927s-2.019-.905-3.311-.882c-1.701.045-3.265.995-4.15 2.511-1.746 3.077-.431 7.602 1.292 10.09.839 1.199 1.859 2.579 3.174 2.511 1.27-.045 1.746-.814 3.288-.814 1.52 0 1.973.814 3.311.792 1.36-.023 2.222-1.245 3.061-2.466.975-1.403 1.36-1.923 1.382-1.991-.022-.023-2.653-1.878-2.698-4.887-.023-2.534 2.064-3.755 2.177-3.823-1.18-1.719-3.016-1.946-3.674-1.968z"
        />
    </svg>
);

export default AppleIconSvg;
